<div class="fixed inset-x-0 top-16 bottom-0 overflow-auto bg-gray-50">
  <!-- Header Section -->
  <div class="sticky top-0 z-20 bg-white w-full shadow">
    <div class="mx-auto max-w-7xl">
      <div class="px-4 py-4">
        <!-- Header Content -->
        <div class="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-between sm:items-center">
          <h1 class="text-2xl font-semibold text-gray-900"></h1>
        
          <!-- Action Buttons -->
          <div class="grid grid-cols-2 gap-3 sm:flex sm:space-x-4">
            <button
              (click)="openInviteVendor()"
              class="inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <svg class="h-5 w-5 sm:mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
              </svg>
              <span class="hidden sm:inline">Invite Vendor</span>
            </button>
            
            <button
              (click)="openCreateVendorTask()"
              class="inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              <svg class="h-5 w-5 sm:mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              <span class="hidden sm:inline">Create Sublet</span>
            </button>
          </div>
        </div>

        <!-- Tabs -->
        <div class="mt-4 border-b border-gray-200">
          <nav class="flex -mb-px">
            <button
              (click)="setActiveTab('vendors')"
              class="px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap"
              [class.text-blue-600]="activeTab === 'vendors'"
              [class.border-blue-600]="activeTab === 'vendors'"
              [class.text-gray-500]="activeTab !== 'vendors'"
              [class.border-transparent]="activeTab !== 'vendors'"
            >
              Assigned Sublets
            </button>
            <button
              (click)="setActiveTab('tasks')"
              class="ml-8 px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap"
              [class.text-blue-600]="activeTab === 'tasks'"
              [class.border-blue-600]="activeTab === 'tasks'"
              [class.text-gray-500]="activeTab !== 'tasks'"
              [class.border-transparent]="activeTab !== 'tasks'"
            >
              Unassigned Sublets
            </button>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="px-4 py-4">
    <div class="mx-auto max-w-7xl">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="flex justify-center items-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>

      <!-- Content based on active tab -->
      <div [ngSwitch]="activeTab">
        <!-- Vendors Tab Content -->
        <div *ngSwitchCase="'vendors'">
          <!-- Table -->
          <div class="mt-8 flow-root">
            <div class="mb-6">
              <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div class="flex items-center gap-3">
                  <div>
                    <h2 class="text-2xl font-bold text-gray-900">Assigned Sublets</h2>
                    <p class="mt-1 text-sm text-gray-500">View assigned sublets for vendors</p>
                  </div>
                  <span class="inline-flex px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                    {{ (vendorTasks$ | async)?.length || 0 }} Tasks
                  </span>
                </div>
                <!-- Add Typeahead Component -->
                <div class="w-64 "> 
                  <lib-type-ahead
                    [config]="typeaheadConfig"
                    (selected)="onVendorSelected($event)"
                    class="w-full"
                    placeholder="Search vendors...">
                  </lib-type-ahead>
                </div>
              </div>
            </div>
            <div *ngIf="!isLoading" >
              <div class="align-middle">
                <div class="hidden md:block overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                  <table class="min-w-full divide-y divide-gray-300">
                    <thead class="bg-gray-50">
                      <tr>
                        <th scope="col" class="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-6 w-1/3">Vendor</th>
                        <!-- Hidden on mobile -->
                        <th scope="col" class="hidden md:table-cell px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Request</th>
                        <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1/4">RO Number</th>
                        <!-- Hidden on mobile -->
                        <th scope="col" class="hidden md:table-cell px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Sent Date</th>
                        <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Status</th>
                        <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Actions</th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 bg-white">
                      <tr *ngFor="let task of vendorTasks$ | async"
                          #vendorTaskRow
                          [attr.data-task-id]="task._id"
                          [ngClass]="{'bg-yellow-100': highlightedTaskId === task._id, 'hover:bg-gray-50': highlightedTaskId !== task._id}"
                          (click)="viewTask(task)"
                          class="cursor-pointer transition-colors duration-150">
                        <td class="py-4 pl-4 pr-3 text-sm sm:pl-6">
                          <div class="flex flex-col items-center">
                            <span class="font-medium text-gray-900 break-words">{{task.tenants?.[0]?.name || 'No Tenant'}}</span>
                            <span class="text-gray-500 break-words ">{{task.tenants?.[0]?.phoneNumber || 'No Phone'}}</span>
                          </div>
                        </td>
                        <!-- Hidden on mobile -->
                        <td class="hidden md:table-cell text-center whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                            {{ task.servicesOffered }}
                          </span>
                        </td>
                        <td class="px-3 py-4 text-sm text-gray-500 break-words text-center">{{task.roNumber}}</td>
                        <!-- Hidden on mobile -->
                        <td class="hidden md:table-cell px-3 py-4 text-sm text-gray-500 text-center">
                          {{task.createdAt | date:'MM/dd/yyyy'}}
                        </td>
                        <td class="px-3 py-4 text-sm text-center">
                          <span class="whitespace-nowrap inline-flex rounded-md px-2 py-1 text-xs font-semibold leading-5"
                            [ngClass]="{
                              'bg-green-50 text-green-800 ring-1 ring-inset ring-green-600/20': task.vendorCompleted === true,
                              'bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-600/20': task.vendorCompleted === false,
                            }">
                            {{task.vendorCompleted ? 'Completed' : 'In Progress'}}
                          </span>
                        </td>
                        <td class="px-3 py-4 text-sm text-center">
                          <button (click)="viewTask(task)" 
                                  class="inline-flex items-center text-gray-500 hover:text-gray-700">
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                            </svg>
                            <span class="sr-only">View Details</span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

           <!-- Mobile Cards (hidden on desktop) -->
          <div class="md:hidden space-y-4 px-0">
            <div *ngFor="let task of vendorTasks$ | async" 
                class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
                [attr.data-task-id]="task._id"
                [ngClass]="{'bg-yellow-100': highlightedTaskId === task._id}">
              <!-- Vendor Info -->
              <div class="p-4">
                <div class="flex items-center justify-between mb-3">
                  <div>
                    <h3 class="font-medium text-gray-900">{{task.tenants?.[0]?.name || 'No Tenant'}}</h3>
                    <p class="text-sm text-gray-500">{{task.tenants?.[0]?.phoneNumber || 'No Phone'}}</p>
                  </div>
                  <span class="whitespace-nowrap inline-flex rounded-md px-2.5 py-0.5 text-xs font-medium"
                        [ngClass]="{
                          'bg-green-50 text-green-800 ring-1 ring-inset ring-green-600/20': task.vendorCompleted === true,
                          'bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-600/20': task.vendorCompleted === false
                        }">
                    {{task.vendorCompleted ? 'Completed' : 'In Progress'}}
                  </span>
                </div>

                <!-- Task Details -->
                <div class="space-y-2 border-t border-gray-100 pt-3">
                  <div class="flex justify-between items-center">
                    <span class="text-sm text-gray-500">RO Number:</span>
                    <span class="text-sm font-medium text-gray-900">{{task.roNumber}}</span>
                  </div>

                  <div class="flex justify-between items-center">
                    <span class="text-sm text-gray-500">Request:</span>
                    <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                      {{task.servicesOffered}}
                    </span>
                  </div>

                  <div class="flex justify-between items-center">
                    <span class="text-sm text-gray-500">Date:</span>
                    <span class="text-sm text-gray-900">{{task.createdAt | date:'MM/dd/yyyy'}}</span>
                  </div>
                </div>

                <!-- Action Button -->
                <button (click)="viewTask(task)" 
                        class="mt-4 w-full bg-gray-50 text-gray-600 py-2 px-4 rounded-md border border-gray-200 hover:bg-gray-100 transition-colors duration-200 flex items-center justify-center">
                  <span class="mr-2">View Details</span>
                  <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Tasks Tab Content -->
        <div *ngSwitchCase="'tasks'" class="mt-4">
          <div class="px-0 lg:px-4">
            <!-- Tasks Header -->
            <div class="mb-6">
              <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <h2 class="text-2xl font-bold text-gray-900">Unassigned Sublets</h2>
                  <p class="mt-1 text-sm text-gray-500">View and manage requests with sublet work</p>
                </div>
                <span class="inline-flex px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium self-start sm:self-center">
                  {{tasksWithSublets?.length || 0}} Tasks
                </span>
              </div>
            </div>

            <!-- Tasks List -->
            <div class="space-y-4">
              <div *ngFor="let task of tasksWithSublets" 
                  class="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-all duration-200 overflow-hidden">
                <div class="p-4">
                  <!-- Task Header -->
                  <div class="flex flex-col gap-4">
                    <!-- Task Info -->
                    <div class="flex items-center justify-between">
                      <h3 class="text-lg font-medium text-gray-900">{{task.request.name}}</h3>
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                            [ngClass]="{
                              'bg-green-100 text-green-800': task.taskCompleted,
                              'bg-yellow-100 text-yellow-800': !task.taskCompleted
                            }">
                        {{task.taskCompleted ? 'Completed' : 'In Progress'}}
                      </span>
                    </div>

                    <!-- Task Details -->
                    <div class="space-y-3">
                      <div class="flex flex-wrap items-center gap-2">
                        <span class="text-sm text-gray-500">Created {{task.createdAt | date:'MMM d, y'}}</span>
                        <span *ngIf="task.isUrgent" 
                              class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-red-100 text-red-800">
                          Urgent
                        </span>
                      </div>

                      <!-- Assignment Info -->
                      <div class="flex flex-col space-y-2">
                        <div class="flex items-center text-sm">
                          <svg class="mr-2 h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                          </svg>
                          <span class="text-gray-600">
                            Assigned to: 
                            <span class="font-medium text-gray-900">{{task.employee?.name || 'Unassigned'}}</span>
                          </span>
                        </div>
                        <div class="flex items-center text-sm">
                          <span class="text-gray-600">
                            From: 
                            <span class="font-medium text-gray-900">{{task.createdBy?.name || 'Unknown'}}</span>
                          </span>
                        </div>
                      </div>

                      <!-- Sublets -->
                      <div *ngIf="task.subletVendorAssignments.length > 0" class="mt-4">
                        <h4 class="text-sm font-medium text-gray-700 mb-2">Sublet Services:</h4>
                        <div class="flex flex-wrap gap-2">
                          <button *ngFor="let sublet of task.subletVendorAssignments"
                                  (click)="handleSubletSelection(sublet, task)"
                                  [disabled]="sublet.isAssigned"
                                  class="inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium 
                                         transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                  [ngClass]="{
                                    'bg-teal-600 text-white cursor-not-allowed opacity-75': task._id && sublet.isAssigned,
                                    'bg-blue-50 text-blue-700 hover:bg-blue-100': !task._id || !sublet.isAssigned
                                  }">
                            {{sublet.subletName}}
                            <svg *ngIf="sublet.isAssigned" class="ml-1.5 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex flex-wrap gap-2 mt-4 pt-4 border-t border-gray-100">
                      <button (click)="openReassignModal(task)" 
                              class="flex items-center px-3 py-1.5 text-sm text-gray-600 bg-gray-50 rounded-md hover:bg-gray-100">
                        <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                        </svg>
                        Reassign
                      </button>

                      <button (click)="openCompleteConfirmation(task)"
                              *ngIf="!task.taskCompleted"
                              class="flex items-center px-3 py-1.5 text-sm text-green-700 bg-green-50 rounded-md hover:bg-green-100">
                        <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                        </svg>
                        Complete
                      </button>

                      <button (click)="openDeleteConfirmation(task)"
                              class="flex items-center px-3 py-1.5 text-sm text-red-700 bg-red-50 rounded-md hover:bg-red-100">
                        <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                        </svg>
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- Empty State -->
            <div *ngIf="!tasksWithSublets?.length && !isLoading" 
                 class="mt-6 text-center bg-white rounded-lg shadow-sm border border-gray-200 p-8">
              <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
              <h3 class="mt-2 text-lg font-medium text-gray-900">No tasks with sublets</h3>
              <p class="mt-1 text-sm text-gray-500">Get started by creating a new task with sublet work.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Dark Overlay -->
      <div *ngIf="isCreatePanelOpen" 
        class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        style="z-index: 40;">
      </div>

      <div *ngIf="isCreatePanelOpen" @slideInOut 
        class="fixed right-0 w-full md:w-2/3 bg-white shadow-xl z-50 transform transition-transform overflow-hidden" 
        [ngClass]="{'-translate-x-full': !isCreatePanelOpen, 'translate-x-0': isCreatePanelOpen}"
        style="top: 64px; bottom: 0;"
      >

          <lib-vendor-associate
           [taskData]="selectedTask"
           (slideOutToggled)="closeCreatePanel()"
           (taskUpdated)="loadVendorTasks()">
          </lib-vendor-associate>   
    </div>


    <div
  *ngIf="isInviteVendorModalVisible"
  class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
>
  <div class="bg-white w-full md:w-1/2 lg:w-1/3 rounded-lg shadow-lg p-6">
    <!-- Modal Header -->
    <div class="flex items-center justify-between mb-4 border-b pb-2">
      <h2 class="text-xl font-semibold text-gray-900">Invite A Vendor</h2>
      <button
        class="text-gray-500 hover:text-gray-700 focus:outline-none"
        (click)="closeInviteVendorModal()"
      >
        ✕
      </button>
    </div>

    <!-- Modal Content -->
    <form [formGroup]="inviteVendorForm" (ngSubmit)="submitInviteVendor()">
      <!-- Vendor Category Dropdown -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Vendor Category</label>
        <select
        formControlName="vendorCategory"
        class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
        <option value="">Select a category</option>
        <option *ngFor="let category of vendorCategories" [value]="category.value">
            {{category.label}}
        </option>
        </select>
        <div *ngIf="inviteVendorForm.get('vendorCategory')?.invalid && inviteVendorForm.get('vendorCategory')?.touched" 
             class="text-red-500 text-sm mt-1">
          Category is required
        </div>
    </div>
      <!-- Contact Name -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Contact Name <span class="text-red-500">*</span></label>
        <input
          formControlName="contactName"
          type="text"
          placeholder="Enter contact name"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
        <div *ngIf="inviteVendorForm.get('contactName')?.invalid && inviteVendorForm.get('contactName')?.touched" class="text-red-500 text-sm mt-1">
          Contact name is required.
        </div>
      </div>

      <!-- Vendor Name -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Vendor Name</label>
        <input
          formControlName="vendorName"
          type="text"
          placeholder="Enter vendor name"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
      </div>

      <!-- Phone Number (Required) -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Phone Number <span class="text-red-500">*</span></label>
        <input
          formControlName="phoneNumber"
          type="tel"
          placeholder="Enter phone number"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
        <div *ngIf="inviteVendorForm.get('phoneNumber')?.invalid && inviteVendorForm.get('phoneNumber')?.touched" class="text-red-500 text-sm mt-1">
          Phone number is required.
        </div>
      </div>

      <!-- Email Address -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
        <input
          formControlName="emailAddress"
          type="email"
          placeholder="Enter email address"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
        />
      </div>

      <!-- Modal Actions -->
      <div class="flex justify-end space-x-2">
        <button
          type="button"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
          (click)="closeInviteVendorModal()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          [disabled]="inviteVendorForm.invalid"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
    
    <!-- Delete Confirmation Modal -->
    <lib-confirmation-modal-tw
      [isOpen]="showDeleteConfirmation"
      [type]="'reject'"
      [title]="'Delete Request'"
      [message]="'Are you sure you want to delete this request? This action cannot be undone.'"
      [confirmButtonText]="'Delete'"
      [cancelButtonText]="'Cancel'"
      (confirm)="confirmDelete()"
      (cancel)="closeDeleteConfirmation()">
    </lib-confirmation-modal-tw>

    <!-- Complete Confirmation Modal -->
    <lib-confirmation-modal-tw
      [isOpen]="showCompleteConfirmation"
      [type]="'approve'"
      [title]="'Complete Request'"
      [message]="'Are you sure you want to mark this request as complete?'"
      [confirmButtonText]="'Complete'"
      [cancelButtonText]="'Cancel'"
      (confirm)="confirmComplete()"
      (cancel)="closeCompleteConfirmation()">
    </lib-confirmation-modal-tw>

        <!-- Reassign Modal -->

        <div *ngIf="showReassignConfirmation" 
        class="fixed inset-0 z-50 flex items-center justify-center">
     <div class="fixed inset-0 bg-gray-500 bg-opacity-75"></div>
     
     <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 z-50">
       <!-- Header -->
       <div class="px-4 py-3 border-b border-gray-200">
         <h3 class="text-lg font-medium text-gray-900">Reassign Task</h3>
         <p class="mt-1 text-sm text-gray-500">Select a user to reassign this task to</p>
       </div>
   
       <!-- User List -->
       <div class="max-h-96 overflow-y-auto">
         <div class="p-4">
           <div class="space-y-2">
             <label *ngFor="let user of filteredUsers"
                   class="flex items-center p-3 hover:bg-gray-50 rounded-lg cursor-pointer">
               <div class="flex items-center flex-1">
                 <div class="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                   <span class="text-gray-600">{{user.name.charAt(0)}}</span>
                 </div>
                 <div>
                   <div class="text-sm font-medium">{{user.name}}</div>
                   <div class="text-sm text-gray-500">{{user.email}}</div>
                 </div>
               </div>
               <input type="radio"
                     [value]="user._id"
                     [(ngModel)]="selectedReassignUser"
                     name="reassignUser"
                     class="h-4 w-4 text-blue-600 border-gray-300">
             </label>
           </div>
         </div>
       </div>
   
       <!-- Action Buttons -->
       <div class="border-t border-gray-200 p-4 flex space-x-3">
         <button type="button"
                 (click)="closeReassignConfirmation()"
                 class="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
           Cancel
         </button>
         <button type="button"
                 (click)="confirmReassign()"
                 [disabled]="!selectedReassignUser"
                 class="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
           Reassign
         </button>
       </div>
     </div>
   </div>
  </div>


<!-- Dark Overlay for Task Detail -->
<div *ngIf="slideOutVisible4"
     class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
     style="z-index: 40;">
</div>

<!-- Sliding Panel for Vendor Associate -->
<div *ngIf="slideOutVisible4" @slideInOut
     class="fixed right-0 w-full md:w-2/3 bg-white shadow-xl z-50 transform transition-transform overflow-hidden" 
     [ngClass]="{'-translate-x-full': !slideOutVisible4, 'translate-x-0': slideOutVisible4}"
     style="top: 64px; bottom: 0;">
  <lib-vendor-associate 
    [taskId]="updTask?._id || null" 
    [taskMedia]="updTask?.media || []"
    (slideOutToggled)="toggleSubletComponent()" 
    [subletSelected]="subletSelected">
  </lib-vendor-associate>
</div>

</div>
